import React from "react";
import "./index.css";

const Footer: React.FC = () => {
  return (
    <footer>
      <p><a href="/">Home</a> | <a href="/about">About</a> | <a href="/contact">Contact</a> | <a href="/posts">Posts</a></p>
      <p>&copy; {new Date().getFullYear()} Sullen Entropy. All rights reserved.</p>
    </footer>
  );
}

export default Footer;